import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {buildPath} from "../../utils";

const AdminRoute = () => {
    const auth = useAuth();
    if (auth && auth.user && (!auth.token || auth.user.role !== "ADMIN")) {
        return <Navigate to={buildPath("/admin")} />;
    }
    return <Outlet />;
};

export default AdminRoute;
